import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getPermissionRoles = async (token, params, municipalityId) => {
  const url = `municipalities/${municipalityId}/permissions/${params.permission_id}/roles`
  const data = await apiGet({ url, params, token })
  return data
}

export function usePermissionRoles({ params, options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getPermissionRoles(token, params, municipality_id)
  const queryKey = ['permissions-roles', params]
  return useQuery(queryKey, queryFn, { ...options })
}
